import {Component, Input} from '@angular/core';
import {NavParams} from "ionic-angular";
import moment from "moment";
import {BookingServiceProvider} from "../../providers/booking-service/booking-service";

/**
 * Generated class for the AdvertComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'paid',
    templateUrl: 'paid.html'
})
export class PaidComponent {

    @Input() currencySymbol;
    @Input() outline;
    @Input() booking;

    isPaid: boolean = false;

    constructor(
      public bookingProvider: BookingServiceProvider
    ){

    }

    ngOnChanges(){
      this.isPaid = this.isBookingPaid();
    }

    isBookingPaid(){
      if (this.bookingProvider.getAmountDue(this.booking) <= 0 && this.booking.total_paid > 0){
        return true;
      }
      return false;
    }

}



// WEBPACK FOOTER //
// ./src/components/paid/paid.ts